// @ts-ignore
import styled from "styled-components";

export const ButtonOverlay = styled.button`
  display: block;
  background: none;
  height: 100%;
  width: 100%;
  border: none;
  height: 64px;
`;

export const LogoGroup = styled.div`
  height: 191px;
  flex-direction: column;
  display: flex;
`;

export const Logo = styled.img`
  max-width: 300px;
  height: 100%;
  align-self: center;
  object-fit: contain;
`;

export const LoginForm = styled.div`
  height: 230px;
  width: 270px;
  flex-direction: column;
  display: flex;
  align-self: center;
  margin: 0 auto;
  margin-top: 30px;

  .jm-ion-btn {
    height: 64px;
    background-color: red;
    border-radius: 5px;
    flex-direction: column;
    display: flex;
    justify-content: center;
    border: none;
    margin-top: 30px;
  }
`;

export const UsernameGroup = styled.div`
  height: 59px;
  background-color: rgba(152, 0, 83, 0.25);
  border-radius: 5px;
  flex-direction: row;
  display: flex;
`;

export const UsernameGroupColumn = styled.div`
  flex-direction: column;
  display: flex;

  .login-input input {
    font-size: 14px !important;
    font-weight: bold !important;
    box-shadow: none !important;
  }
`;

export const PasswordGroup = styled.div`
  height: 59px;
  background-color: rgba(152, 0, 83, 0.25);
  border-radius: 5px;
  flex-direction: row;
  display: flex;
  margin-top: 27px;
`;

export const UsernameGroupColumnFiller = styled.div`
  flex: 1 1 0%;
  flex-direction: column;
  display: flex;
  margin-top: 27px;
`;

export const BtnLoginText = styled.div`
  font-family: Arial;
  color: rgba(255, 255, 255, 1);
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
`;
